export const DAO_CODE = 'SERVICES' + '_DAO';
